import { render, staticRenderFns } from "./ChooseAssociated.vue?vue&type=template&id=5d50dde9&scoped=true&"
import script from "./ChooseAssociated.vue?vue&type=script&lang=ts&"
export * from "./ChooseAssociated.vue?vue&type=script&lang=ts&"
import style0 from "./ChooseAssociated.vue?vue&type=style&index=0&id=5d50dde9&lang=less&scoped=true&"
import style1 from "./ChooseAssociated.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d50dde9",
  null
  
)

component.options.__file = "ChooseAssociated.vue"
export default component.exports